import type * as React from "react";
import { useHistory } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { PATHS } from "constants/pathConstants";
import PageTitle from "utils/PageTitle";
import GradientFramedLayout from "components/v3/layouts/GradientFramedLayout";
import BreadcrumbTrail from "components/v3/sharedComponents/BreadcrumbTrail";
import ProfileForm, {
  type ProfileFormFields
} from "components/v3/forms/ProfileForm";

const MEMBER_INFO_HEADING = "Member Information";

const MemberInfoPage: React.FC = () => {
  const history = useHistory();

  PageTitle(MEMBER_INFO_HEADING);

  const handleSubmitted = (_formFields: ProfileFormFields) => {
    history.push(PATHS.ACCOUNT_MANAGEMENT);
  };

  return (
    <GradientFramedLayout showHeader={true}>
      <Box
        sx={{
          alignItems: "stretch",
          alignSelf: "stretch",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          gap: 3,
          marginX: "auto",
          maxWidth: { md: 840, xs: "100%" },
          minWidth: 0,
          paddingBottom: "40px",
          paddingTop: { md: 3, xs: 2 },
          paddingX: { md: 3, xs: 2 },
          width: "100%"
        }}
      >
        <Typography
          variant="h4_primary"
          component="h1"
          sx={{ fontWeight: 700, textAlign: "left", width: "100%" }}
        >
          {MEMBER_INFO_HEADING}
        </Typography>

        <BreadcrumbTrail
          segments={[
            { label: "Account", to: PATHS.ACCOUNT_MANAGEMENT },
            { label: MEMBER_INFO_HEADING }
          ]}
        />

        <Box sx={{ minWidth: 0, width: "100%" }}>
          <ProfileForm
            onFormFieldsUpdated={() => {}}
            onSubmitted={handleSubmitted}
          />
        </Box>
      </Box>
    </GradientFramedLayout>
  );
};

export default MemberInfoPage;
